import { combineReducers } from '@reduxjs/toolkit';
import { reducer as dataControllerReducer } from '../slices/dataController';
import { reducer as identyumControllerReducer } from '../slices/identyumController';
import { reducer as processMonitorReducer } from '../slices/processMonitor';
import { reducer as psd2ControllerReducer } from '../slices/psd2Controller';
import { reducer as tosControllerReducer } from '../slices/tosController';

const rootReducer = combineReducers({
    processMonitor: processMonitorReducer,
    dataController: dataControllerReducer,
    tosController: tosControllerReducer,
    identyumController: identyumControllerReducer,
    psd2Controller: psd2ControllerReducer,
});

export default rootReducer;
